export class SensorGroupNodePermissionsInputDto {
  userGroupIds: number[];
  userIds: number[];
}
